import NewHeader from "../components/NewHeader_dev";
import NoticeCSS from "./Notice.module.css";
import Footer from "../components/Footer";
import Loader from '../components/Loader'
import React,{useState,useEffect} from 'react'

function Notice() {
  return (
    <div className={NoticeCSS.content}>
    <NewHeader />
    <br />
    <div>
          <p>
            <table>
              <tr>
                <th>
                주식회사 스마투스코리아 공고
                </th>
              </tr>
              <tr>
                <td>
                <br />
                (주)스마투스코리아(이하 "회사")는 상법 및 당사 정관에 따라 유상증자를 결의하는바, 다음과 같이 신주 발행의 내용을 예정 공고합니다.<br />
<br />
당사 이사회(2026년 8월 11일 결의)에 따라 아래와 같이 주주 및 제3자 배정 방식의 유상증자를 실시할 예정입니다.<br />
- 신주의 종류와 수: 전환상환우선주 1,990주<br />
- 1주의 액면가액: 500원<br />
- 신주의 발행가액: 72,240원<br />
- 신주의 납입총액: 143,757,600원<br />
- 청약일: 2026년 8월 21일<br />
- 납입기일: 2026년 8월 21일<br />
- 납입은행: 기업은행 노량진지점 (인터넷 납입 및 증명 가능)<br />
- 신주의 인수방법: 상법 제418조 제1항, 제2항 및 당사 정관 제9조 제2항에 따라 기존 주주 및 기존 주주가 지정하는 제3자에게 배정<br />
본 유상증자는 회사의 경영상 목적을 달성하기 위한 목적으로 진행될 예정입니다.<br />
본 공고는 회사 정관 제4조(공고방법)에 따라 인터넷 홈페이지를 통해 공시하는 것으로, 관련 상세 내용은 본사에 비치된 이사회 의사록에서 열람하실 수 있습니다.<br />
<br /><br />
2026년 8월 6일<br />
서울특별시 마포구 백범로31길 21, 창업허브별관 405호<br />
주식회사 스마투스코리아<br />
<br />
<br />
</td>
              </tr>
            </table>
</p>
          <br />
          <br />
        <Footer />
      </div>
    </div>
  );
}
export default Notice;
